//rafce
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import './style.scss';

import parteGrowth from '../../assets/img/cardapio-full/vs2026-03/chiquinho-banner-edicao-linha-proteica-growth-supplements-01.jpg';
import parte1 from '../../assets/img/cardapio-full/vs2026-03/chiquinho-cardapio-online-01.jpg';
import parte2 from '../../assets/img/cardapio-full/vs2026-03/chiquinho-cardapio-online-02.jpg';
import parte3 from '../../assets/img/cardapio-full/vs2026-03/chiquinho-cardapio-online-03.jpg';
import parte4 from '../../assets/img/cardapio-full/vs2026-03/chiquinho-cardapio-online-04.jpg';
import parte5 from '../../assets/img/cardapio-full/vs2026-03/chiquinho-cardapio-online-05.jpg';
import parte6 from '../../assets/img/cardapio-full/vs2026-03/chiquinho-cardapio-online-06.jpg';
import parte8 from '../../assets/img/cardapio-full/vs2026-03/chiquinho-cardapio-online-08.jpg';
import parte9 from '../../assets/img/cardapio-full/vs2026-03/chiquinho-cardapio-online-09.jpg';

import api from '../../services/api';

const CardapioOnlineFull = () => {
  const { franquia } = useParams();
  const history = useHistory();

  const [loadingModal, setLoaddingModal] = useState(false);
  const [mostraModalCatchPrecos, setMostraModalCatchPrecos] = useState(false);

  const [products, setProducts] = useState([]);

  const [pos102000298, setPos102000298] = useState({}); /*Torta de Morango*/
  const [pos102000324, setPos102000324] = useState({}); /*Merengue de Limão*/
  const [pos102000348, setPos102000348] = useState({}); /*Merengue de Morango*/
  const [pos102000336, setPos102000336] = useState({}); /*Floresta Negra*/
  const [pos102000311, setPos102000311] = useState({}); /*S´mores*/

  const [pos102000279, setPos102000279] = useState({}); /*Monte o seu canecake*/

  const [pos110000259, setPos110000259] = useState({}); /*Suspiro*/
  const [pos110000203, setPos110000203] = useState({}); /*Morango*/
  const [pos110000206, setPos110000206] = useState({}); /*Doce de Leite*/
  const [pos110000256, setPos110000256] = useState({}); /*Creme Amarena*/
  const [pos110000207, setPos110000207] = useState({}); /*Chocolate Trufado*/
  const [pos110000204, setPos110000204] = useState({}); /*Banana*/
  const [pos110000208, setPos110000208] = useState({}); /*Creme de Leite em Pó*/
  const [pos110000205, setPos110000205] = useState({}); /*NUTELLA*/
  const [pos110000210, setPos110000210] = useState({}); /*Leite Moça*/
  const [pos110000231, setPos110000231] = useState({}); /*Creme de Pistache*/
//   const [pos110000257, setPos110000257] = useState({}); /*Marshmallow Cremoso - Borda*/
  const [pos110000258, setPos110000258] = useState({}); /*Marshmallow Cremoso - Recheio*/
  const [pos110000213, setPos110000213] = useState({}); /*Disqueti*/
  const [pos110000214, setPos110000214] = useState({}); /*Calda de Fondue*/
  const [pos110000242, setPos110000242] = useState({}); /*Creme Coco da Malásia*/
  const [pos110000222, setPos110000222] = useState({}); /*Creme Crocante Ovomaltine*/
  const [pos102000269, setPos102000269] = useState({}); /*Top Fondue - Banana*/
  const [pos102000265, setPos102000265] = useState({}); /*Top Fondue - Morango*/
  const [pos102000272, setPos102000272] = useState({}); /*Top Fondue - Uva*/
  const [pos102000256, setPos102000256] = useState({}); /*Fondue - Banana - 200ml*/
  const [pos102000259, setPos102000259] = useState({}); /*Fondue - Banana - 300ml*/
  const [pos102000257, setPos102000257] = useState({}); /*Fondue - Morango - 200ml*/
  const [pos102000258, setPos102000258] = useState({}); /*Fondue - Morango - 300ml*/
  const [pos102000260, setPos102000260] = useState({}); /*Fondue - Uva - 200ml*/
  const [pos102000261, setPos102000261] = useState({}); /*Fondue - Uva - 300ml*/
  const [pos102000262, setPos102000262] = useState({}); /*Mix Fondue - Banana, Morango e Uva - 200ml*/
  const [pos102000263, setPos102000263] = useState({}); /*Mix Fondue - Banana, Morango e Uva - 300ml*/
  const [pos102000349, setPos102000349] = useState({}); /*Café - Cappuccino - 200ml*/

  const [pos101900026, setPos101900026] = useState({}); /*Shake Mix - Banoffee - 200ml*/
  const [pos100700135, setPos100700135] = useState({}); /*Shake Mix - Banoffee - 300ml*/

  const [pos101900027, setPos101900027] = useState({}); /*Shake Mix - Torta de Limão - 200ml*/
  const [pos100700133, setPos100700133] = useState({}); /*Shake Mix - Torta de Limão - 300ml*/



//   const [pos101900110, setPos101900110] = useState({}); /*Mini Shake mix - Pistache Dubai - 200ml*/


//   const [pos100200166, setPos100200166] = useState({}); /*Cascão Kitkat® - Baunilha*/
//   const [pos101900116, setPos101900116] = useState({}); /*Shake Mix KitKat® 200 ml*/
//   const [pos100700151, setPos100700151] = useState({}); /*Shake Mix KitKat® 300 ml*/

  //Promo - Especialidades
  const [pos101900105, setPos101900105] = useState({}); /*Mini Shake Mix Amarena & Calda Trufada*/
  const [pos101900104, setPos101900104] = useState({}); /*Mini Shake Mix Beijinho c/ Coco da Malásia - 200ml*/
  const [pos100700138, setPos100700138] = useState({}); /*Shake Mix Beijinho c/ Coco da Malásia - 300ml*/
  

  const [pos101300014, setPos101300014] = useState({}); /*Big Sundae Chocotino Turbo - 300ml - Chocolate, Baunilha e Misto */


  //Chiquinho & Nutella - Cascão
  //Nutella e Banana
  const [pos100200137, setPos100200137] = useState({}); //Milk-shakes - fabulosos - 300ml
  //Nutella e Morango
  const [pos100200140, setPos100200140] = useState({}); //Milk-shakes - fabulosos - 400ml
  
  //milk-shakes - tradicionais
  const [pos100300003, setPos100300003] = useState({}); //Milk-shakes - tradicionais - 300ml
  const [pos100400003, setPos100400003] = useState({}); //Milk-shakes - tradicionais - 400ml
  const [pos100500003, setPos100500003] = useState({}); //Milk-shakes - tradicionais - 500ml

  //milk-shakes - receitas especiais
//   const [pos100300171, setPos100300171] = useState({}); //Milk-shakes - pink lemonade - 300ml
//   const [pos100300170, setPos100300170] = useState({}); //Milk-shakes - Napolitano - 300ml
//   const [pos100300169, setPos100300169] = useState({}); //Milk-shakes - Três Leites - 300ml
  const [pos100300176, setPos100300176] = useState({}); //Milk-shake Chocotino Turbo - 300ml  

  //shake-mix
  const [pos100700023, setPos100700023] = useState({}); //Shake Mix® Ninho com NUTELLA® 300 ml
  const [pos101900001, setPos101900001] = useState({}); //Shake Mix® Ninho com NUTELLA® 200 ml
  const [pos100700009, setPos100700009] = useState({}); //classicos - 300ml
  const [pos101900015, setPos101900015] = useState({}); //classicos - mini - 200ml
  
  //shake-mix - NUTELLA
  //const [pos101900098, setPos101900098] = useState({}); //insuperáveis - 200ml
  //const [pos100700128, setPos100700128] = useState({}); //insuperáveis - 300ml


  //shake-mix - receitas especiais
  //const [pos101900027, setPos101900027] = useState({}); //shake-mix - Torta de Limão - 200ml

  //top mix
//   const [pos100600013, setPos100600013] = useState({}); //chocolate preferido
  const [pos100600034, setPos100600034] = useState({}); //com frutas

  //ovomaltine
  const [pos100800049, setPos100800049] = useState({}); //Sundae - Ovomaltine - 200ml
  const [pos100200067, setPos100200067] = useState({}); //Cascão Trufado Ovomaltine
  const [pos100100032, setPos100100032] = useState({}); //Casquinha Trufada

  const [pos101900019, setPos101900019] = useState({}); //Ovomaltine Mix 200ml
  const [pos100700017, setPos100700017] = useState({}); //Ovomaltine Mix 300ml

  //mix fruit
  const [pos101100003, setPos101100003] = useState({}); //200ml

  //big sundae
  const [pos101300006, setPos101300006] = useState({}); //Big sundae - 300ml
  const [pos100800014, setPos100800014] = useState({}); //Sundae - 200ml

  //casquinhas e cascões - tradicionais
  const [pos100100013, setPos100100013] = useState({}); //Tradicionais - Casquinha
  const [pos100200043, setPos100200043] = useState({}); //Tradicionais - Cascão

  //casquinhas e cascões - trufadas
  const [pos100100016, setPos100100016] = useState({}); //Trufadas - Casquinha
  const [pos100200053, setPos100200053] = useState({}); //Trufadas - Cascão

  //casquinhas e cascões - trufadas - PISTACHE
  const [pos100100057, setPos100100057] = useState({}); //Trufadas - Casquinha - Pistache
  const [pos100200143, setPos100200143] = useState({}); //Trufadas - Cascão - Pistache

  //casquinhas e cascões - calda quente
  const [pos100100006, setPos100100006] = useState({}); //Calda quente - Casquinha coberta
  const [pos100100007, setPos100100007] = useState({}); //Calda quente - Casquinha recheada
  const [pos100200004, setPos100200004] = useState({}); //Calda quente - Cascão coberto
  const [pos100200007, setPos100200007] = useState({}); //Calda quente - Cascão recheado

  //petit gateau
  const [pos101500001, setPos101500001] = useState({});

  //bubble waffle
//   const [pos290900031, setPos290900031] = useState({}); //bubble waffle G
//   const [pos290900022, setPos290900022] = useState({}); //bubble waffle P
  
  //bubble waffle - adicionais
//   const [pos290900035, setPos290900035] = useState({}); // Morango P
//   const [pos290900001, setPos290900001] = useState({}); // Morango
//   const [pos290900036, setPos290900036] = useState({}); // Banana P
//   const [pos290900002, setPos290900002] = useState({}); // Banana
//   const [pos290900003, setPos290900003] = useState({}); // Nutella
//   const [pos290900004, setPos290900004] = useState({}); // Doce de Leite
//   const [pos290900005, setPos290900005] = useState({}); // Chocolate Trufado
//   const [pos290900037, setPos290900037] = useState({}); // Polpa de Frutas Vermelhas P
//   const [pos290900006, setPos290900006] = useState({}); // Polpa de Frutas Vermelhas G
//   const [pos290900045, setPos290900045] = useState({}); // Polpa de Morango P
//   const [pos290900019, setPos290900019] = useState({}); // Polpa de Morango
//   const [pos290900007, setPos290900007] = useState({}); // Leite Condensado
//   const [pos290900008, setPos290900008] = useState({}); // Suflair
//   const [pos290900009, setPos290900009] = useState({}); // Kitkat
  
//   const [pos290900010, setPos290900010] = useState({}); // Disqueti P
//   const [pos290900034, setPos290900034] = useState({}); // Disqueti
//   const [pos290900038, setPos290900038] = useState({}); // Biju P
//   const [pos290900011, setPos290900011] = useState({}); // Biju
//   const [pos290900039, setPos290900039] = useState({}); // Granulado Chocolate P
//   const [pos290900012, setPos290900012] = useState({}); // Granulado Chocolate
//   const [pos290900040, setPos290900040] = useState({}); // Farofa Especial P
//   const [pos290900013, setPos290900013] = useState({}); // Farofa Especial
//   const [pos290900041, setPos290900041] = useState({}); // Amendoim Granulado P
//   const [pos290900014, setPos290900014] = useState({}); // Amendoim Granulado
//   const [pos290900042, setPos290900042] = useState({}); // Ganache Chiquinho P
//   const [pos290900015, setPos290900015] = useState({}); // Ganache Chiquinho
//   const [pos290900043, setPos290900043] = useState({}); // Ovomaltine em Flocos P
//   const [pos290900016, setPos290900016] = useState({}); // Ovomaltine em Flocos
//   const [pos290900017, setPos290900017] = useState({}); // Creme Crocante de Ovomaltine
//   const [pos290900044, setPos290900044] = useState({}); // Marshmallow Fini P
//   const [pos290900018, setPos290900018] = useState({}); // Marshmallow Fini

  // cafés e chocolates
  const [pos103000247, setPos103000247] = useState({}); /*Cafés e chocolates: Affogato 200ml (expresso com sorvete) */
  const [pos103000098, setPos103000098] = useState({});
  const [pos103000099, setPos103000099] = useState({});
  const [pos103000249, setPos103000249] = useState({});
//   const [pos102000195, setPos102000195] = useState({}); /*Cafés e chocolates: Chocolate (quente ou frio) 200ml */
//   const [pos102000197, setPos102000197] = useState({});

  //Café shake
  const [pos100300072, setPos100300072] = useState({}); // Nutella
  const [pos100300070, setPos100300070] = useState({}); // Tradicional
//   const [pos100300071, setPos100300071] = useState({}); // Doce de Leite
  const [pos100300172, setPos100300172] = useState({}); // Trufado
//   const [pos100300173, setPos100300173] = useState({}); // Doce de Leite


  //açaí - monte o seu
  const [pos101400011, setPos101400011] = useState({}); // 300ml
  const [pos101400013, setPos101400013] = useState({}); // 400ml
  const [pos101400014, setPos101400014] = useState({}); // 500ml

  //açaí - turbine
  const [pos110000151, setPos110000151] = useState({});
  const [pos110000176, setPos110000176] = useState({});
  const [pos110000075, setPos110000075] = useState({});
  const [pos110000077, setPos110000077] = useState({});
  const [pos110000149, setPos110000149] = useState({});
  const [pos110000069, setPos110000069] = useState({});
  const [pos110000068, setPos110000068] = useState({});
  const [pos110000172, setPos110000172] = useState({});

  const [pos110000173, setPos110000173] = useState({});
  const [pos110000174, setPos110000174] = useState({});
  const [pos110000167, setPos110000167] = useState({});
  const [pos110000168, setPos110000168] = useState({});
  const [pos110000169, setPos110000169] = useState({});
  const [pos110000070, setPos110000070] = useState({});
  const [pos110000150, setPos110000150] = useState({});
  const [pos110000072, setPos110000072] = useState({});

  //add especiais
  const [pos110000076, setPos110000076] = useState({});
  const [pos110000071, setPos110000071] = useState({});
  const [pos110000073, setPos110000073] = useState({});
  const [pos110000152, setPos110000152] = useState({});
  const [pos110000153, setPos110000153] = useState({});

  const [pos110000175, setPos110000175] = useState({});
  const [pos110000171, setPos110000171] = useState({});
  const [pos110000074, setPos110000074] = useState({});
  const [pos110000170, setPos110000170] = useState({});

  //chiquinho no pote
  const [pos101700005, setPos101700005] = useState({}); // incomparáveis
  const [pos101700002, setPos101700002] = useState({}); // populares





  const [pos101900103, setPos101900103] = useState({}); // Shake Mix - Puro Leite - Leitíssimo - 200ml
  const [pos100700136, setPos100700136] = useState({}); // Shake Mix - Puro Leite - 300ml
  const [pos101900028, setPos101900028] = useState({}); // Shake Mix - Pistache - 200ml
  const [pos100700134, setPos100700134] = useState({}); // Shake Mix - Pistache - 300ml

  const [pos100700137, setPos100700137] = useState({}); // Shake Mix - Amarena & Calda Trufada - 300ml

//   const [pos100400106, setPos100400106] = useState({}); // Milk shake - Receitas especiais - Pink Lemonade - 400ml
//   const [pos100500107, setPos100500107] = useState({}); // Milk shake - Receitas especiais - Pink Lemonade - 500ml
   
//   const [pos100400107, setPos100400107] = useState({}); // Milk shake - Receitas especiais - Napolitano - 400ml
//   const [pos100500106, setPos100500106] = useState({}); // Milk shake - Receitas especiais - Napolitano - 500ml

//   const [pos100400108, setPos100400108] = useState({}); // Milk shake - Receitas especiais - Três Leites - 400ml
//   const [pos100500105, setPos100500105] = useState({}); // Milk shake - Receitas especiais - Três Leites - 500ml
  const [pos100300182, setPos100300182] = useState({}); // Milk shake - Receitas especiais - Amarena & Calda Quente - 300ml
  const [pos100400136, setPos100400136] = useState({}); // Milk shake - Receitas especiais - Amarena & Calda Quente - 400ml
  const [pos100500138, setPos100500138] = useState({}); // Milk shake - Receitas especiais - Amarena & Calda Quente - 500ml
  const [pos100300181, setPos100300181] = useState({}); // Milk shake - Receitas especiais - Beijinho c/ Coco da Malásia - 300ml
  const [pos100400137, setPos100400137] = useState({}); // Milk shake - Receitas especiais - Beijinho c/ Coco da Malásia - 400ml
  const [pos100500139, setPos100500139] = useState({}); // Milk shake - Receitas especiais - Beijinho c/ Coco da Malásia - 500ml
  const [pos100300178, setPos100300178] = useState({}); // Milk shake - Receitas especiais - Pistache - 300ml
  const [pos100400138, setPos100400138] = useState({}); // Milk shake - Receitas especiais - Pistache - 400ml
  const [pos100500140, setPos100500140] = useState({}); // Milk shake - Receitas especiais - Pistache - 500ml
  const [pos100300180, setPos100300180] = useState({}); // Milk shake - Receitas especiais - Puro Leite - 300ml
  const [pos100400135, setPos100400135] = useState({}); // Milk shake - Receitas especiais - Puro Leite - 400ml
  const [pos100500137, setPos100500137] = useState({}); // Milk shake - Receitas especiais - Puro Leite - 500ml
  const [pos100300037, setPos100300037] = useState({}); // Milk shake - Receitas especiais - Nutella - 300ml
  const [pos100400037, setPos100400037] = useState({}); // Milk shake - Receitas especiais - Nutella - 400ml
  const [pos100500037, setPos100500037] = useState({}); // Milk shake - Receitas especiais - Nutella - 500ml

  const [pos100400110, setPos100400110] = useState({}); // Milk shake - Receitas especiais - Chocotino Turbo - 400ml
  const [pos100500110, setPos100500110] = useState({}); // Milk shake - Receitas especiais - Chocotino Turbo - 500ml

  const [pos101900002, setPos101900002] = useState({}); // Chiquinho & Nutella - Shake mix - Chocotino c/ Nutella - 200ml
  const [pos100700005, setPos100700005] = useState({}); // Chiquinho & Nutella - Shake mix - Chocotino c/ Nutella - 300ml
  const [pos101900006, setPos101900006] = useState({}); // Chiquinho & Nutella - Shake mix - Ninho c/ Nutella - 200ml
  //const [pos100700023, setPos100700023] = useState({}); // Shake Mix® Ninho com NUTELLA® 300 ml
  const [pos101900020, setPos101900020] = useState({}); // Chiquinho & Nutella - Shake mix - Trufado de Nutella - 200ml
  const [pos100700042, setPos100700042] = useState({}); // Chiquinho & Nutella - Shake mix - Trufado de Nutella - 300ml
  const [pos101900012, setPos101900012] = useState({}); // Chiquinho & Nutella - Shake mix - Açaí c/ Nutella - 200ml
  const [pos100700018, setPos100700018] = useState({}); // Chiquinho & Nutella - Shake mix - Açaí c/ Nutella - 300ml
  const [pos101900029, setPos101900029] = useState({}); // Chiquinho & Nutella - Shake mix - Morango Supremo (Leite Ninho, Morango e Nutella ) - 200ml
  const [pos100700132, setPos100700132] = useState({}); // Chiquinho & Nutella - Shake mix - Morango Supremo (Leite Ninho, Morango e Nutella ) - 300ml 
//   const [pos100700014, setPos100700014] = useState({}); // Chiquinho & Nutella - Shake mix - Nutella c/ Fini - 200ml
//   const [pos100700139, setPos100700139] = useState({}); // Chiquinho & Nutella - Shake mix - Nutella c/ Fini - 300ml

  const [pos110000032, setPos110000032] = useState({}); // Turbine o seu pedido - Nutela
  const [pos110000028, setPos110000028] = useState({}); // Turbine o seu pedido - Leite Ninho
  const [pos110000014, setPos110000014] = useState({}); // Turbine o seu pedido - Chantilly
  //const [pos150100004, setPos150100004] = useState({}); // Turbine o seu pedido - Água s/ Gás
  //const [pos150100002, setPos150100002] = useState({}); // Turbine o seu pedido - Água c/ Gás

  const [pos101000003, setPos101000003] = useState({}); // Top fruit - 300ml

  const [pos100800020, setPos100800020] = useState({}); // Sundae - Disqueti
  const [pos100800019, setPos100800019] = useState({}); // Sundae - Brigadeiro

  const [pos101500004, setPos101500004] = useState({}); // Bolinho de Petit Gateau - 1 unidade
  const [pos101500005, setPos101500005] = useState({}); // Bolinho de Petit Gateau - 4 unidades
//   const [pos110000013, setPos110000013] = useState({}); // Casquinhas - 1 unidade
  const [pos110000136, setPos110000136] = useState({}); // Casquinhas - 10 unidades
//   const [pos110000011, setPos110000011] = useState({}); // Cascão - 1 unidade
  const [pos110000145, setPos110000145] = useState({}); // Cascão - 10 unidades
  
  //const [pos101900026, setPos101900026] = useState({}); /*Mini Shake Mix Pistache 200 ml*/
//   const [pos100300194, setPos100300194] = useState({}); /*Milk Shake - Pistache Dubai - 300 ml*/
    
  //bebidas
  const [pos150100004, setPos150100004] = useState({}); // Água sem gás
  const [pos150100002, setPos150100002] = useState({}); // Água com gás
  //const [pos000000001, setPos000000001] = useState({}); // Refrigerante
  //const [pos000000002, setPos000000002] = useState({}); // Suco

  const [pos100300038, setPos100300038] = useState({}); //milk shake - Fabulosos - Milk Shake Chocotino - 300 ml
  const [pos100400038, setPos100400038] = useState({}); //milk shake - Fabulosos - Milk Shake Chocotino - 400ml
  const [pos100500038, setPos100500038] = useState({}); //milk shake - Fabulosos - Milk Shake Chocotino - 500ml

  // Linha Proteica Growth Supplements
  // Smoothie Proteico
  const [pos291000004, setPos291000004] = useState({}); /*Açaí 300ml*/
  const [pos291000005, setPos291000005] = useState({}); /*Açaí 400ml*/
  const [pos291000007, setPos291000007] = useState({}); /*Açaí 500ml*/
  const [pos291000001, setPos291000001] = useState({}); /*Açaí com Banana 300ml*/
  const [pos291000002, setPos291000002] = useState({}); /*Açaí com Banana 400ml*/
  const [pos291000003, setPos291000003] = useState({}); /*Açaí com Banana 500ml*/

  // Turbine seu Smoothie com adicionais
  const [pos110000022, setPos110000022] = useState({}); /*Doce de leite*/
  //const [pos110000028, setPos110000028] = useState({}); /*Leite em pó*/
  const [pos110000027, setPos110000027] = useState({}); /*Leite Moça*/
  const [pos110000130, setPos110000130] = useState({}); /*Granola*/
  const [pos110000261, setPos110000261] = useState({}); /*Whey*/
  const [pos110000024, setPos110000024] = useState({}); /*Farofa especial*/

  // Shake Mix Proteico
  const [pos101900123, setPos101900123] = useState({}); /*Banoffee 200ml*/
  const [pos100700153, setPos100700153] = useState({}); /*Banoffee 300ml*/
  const [pos101900124, setPos101900124] = useState({}); /*Farinha Láctea c/ Banana 200ml*/
  const [pos100700154, setPos100700154] = useState({}); /*Farinha Láctea c/ Banana 300ml*/

  // Milk Shake Proteico
  const [pos100300203, setPos100300203] = useState({}); /*Chocolate 300ml*/
  const [pos100400147, setPos100400147] = useState({}); /*Chocolate 400ml*/
  const [pos100500149, setPos100500149] = useState({}); /*Chocolate 500ml*/
  const [pos100300206, setPos100300206] = useState({}); /*Morango 300ml*/
  const [pos100400150, setPos100400150] = useState({}); /*Morango 400ml*/
  const [pos100500152, setPos100500152] = useState({}); /*Morango 500ml*/
  const [pos100300204, setPos100300204] = useState({}); /*Duo Chocolate 300ml*/
  const [pos100400148, setPos100400148] = useState({}); /*Duo Chocolate 400ml*/
  const [pos100500150, setPos100500150] = useState({}); /*Duo Chocolate 500ml*/
  const [pos100300205, setPos100300205] = useState({}); /*Maracujá 300ml*/
  const [pos100400149, setPos100400149] = useState({}); /*Maracujá 400ml*/
  const [pos100500151, setPos100500151] = useState({}); /*Maracujá 500ml*/
  const [pos100300207, setPos100300207] = useState({}); /*Leite em pó 300ml*/
  const [pos100400151, setPos100400151] = useState({}); /*Leite em pó 400ml*/
  const [pos100500153, setPos100500153] = useState({}); /*Leite em pó 500ml*/


  useEffect(() => {
    async function getProducts() {
      const options = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      setLoaddingModal(true);
      try {
        await api
          .get(
            `cardapio/${franquia}?key=2c87f686890c3edc89ae640aa360eb01`,
            options,
          )
          .then(res => {
            const productsMap = res.data.map(product => product);
            setProducts(productsMap);
          });

        setLoaddingModal(false);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setMostraModalCatchPrecos(true);
        }
      }

      setLoaddingModal(false);
    }

    getProducts();
  }, [franquia]);

  useEffect(() => {
    if (products.length > 0) {

  
  setPos102000298(products.find(prod => prod.codigo === "102000298")); // Torta de Morango
  setPos102000324(products.find(prod => prod.codigo === "102000324")); // Merengue de Limão
  setPos102000348(products.find(prod => prod.codigo === "102000348")); // Merengue de Morango
  setPos102000336(products.find(prod => prod.codigo === "102000336")); // Floresta Negra
  setPos102000311(products.find(prod => prod.codigo === "102000311")); // S´mores

  setPos102000279(products.find(prod => prod.codigo === "102000279")); // Monte o seu canecake

  setPos110000259(products.find(prod => prod.codigo === "110000259")); // Suspiro
  setPos110000203(products.find(prod => prod.codigo === "110000203")); // Morango
  setPos110000206(products.find(prod => prod.codigo === "110000206")); // Doce de Leite
  setPos110000256(products.find(prod => prod.codigo === "110000256")); // Creme Amarena
  setPos110000207(products.find(prod => prod.codigo === "110000207")); // Chocolate Trufado
  setPos110000204(products.find(prod => prod.codigo === "110000204")); // Banana
  setPos110000208(products.find(prod => prod.codigo === "110000208")); // Creme de Leite em Pó
  setPos110000205(products.find(prod => prod.codigo === "110000205")); // NUTELLA
  setPos110000210(products.find(prod => prod.codigo === "110000210")); // Leite Moça
  setPos110000231(products.find(prod => prod.codigo === "110000231")); // Creme de Pistache
//   setPos110000257(products.find(prod => prod.codigo === "110000257")); // Marshmallow Cremoso - Borda
  setPos110000258(products.find(prod => prod.codigo === "110000258")); // Marshmallow Cremoso - Recheio
  setPos110000213(products.find(prod => prod.codigo === "110000213")); // Disqueti
  setPos110000214(products.find(prod => prod.codigo === "110000214")); // Calda de Fondue
  setPos110000242(products.find(prod => prod.codigo === "110000242")); // Creme Coco da Malásia
  setPos110000222(products.find(prod => prod.codigo === "110000222")); // Creme Crocante Ovomaltine
  setPos102000269(products.find(prod => prod.codigo === "102000269")); // Top Fondue - Banana
  setPos102000265(products.find(prod => prod.codigo === "102000265")); // Top Fondue - Morango
  setPos102000272(products.find(prod => prod.codigo === "102000272")); // Top Fondue - Uva
  setPos102000256(products.find(prod => prod.codigo === "102000256")); // Fondue - Banana - 200ml
  setPos102000259(products.find(prod => prod.codigo === "102000259")); // Fondue - Banana - 300ml
  setPos102000257(products.find(prod => prod.codigo === "102000257")); // Fondue - Morango - 200ml
  setPos102000258(products.find(prod => prod.codigo === "102000258")); // Fondue - Morango - 300ml
  setPos102000260(products.find(prod => prod.codigo === "102000260")); // Fondue - Uva - 200ml
  setPos102000261(products.find(prod => prod.codigo === "102000261")); // Fondue - Uva - 300ml
  setPos102000262(products.find(prod => prod.codigo === "102000262")); // Mix Fondue - Banana, Morango e Uva - 200ml
  setPos102000263(products.find(prod => prod.codigo === "102000263")); // Mix Fondue - Banana, Morango e Uva - 300ml
  setPos102000349(products.find(prod => prod.codigo === "102000349")); // Café - Cappuccino - 200ml

  setPos101900026(products.find(prod => prod.codigo === "101900026")); // Shake Mix - Banoffee - 200ml
  setPos100700135(products.find(prod => prod.codigo === "100700135")); // Shake Mix - Banoffee - 300ml

  setPos101900027(products.find(prod => prod.codigo === "101900027")); // Shake Mix - Torta de Limão - 200ml
  setPos100700133(products.find(prod => prod.codigo === "100700133")); // Shake Mix - Torta de Limão - 300ml

  setPos101900103(products.find(prod => prod.codigo === "101900103")); // Shake Mix - Puro Leite - Leitíssimo - 200ml
  setPos100700136(products.find(prod => prod.codigo === "100700136")); // Shake Mix - Puro Leite - 300ml
  setPos101900028(products.find(prod => prod.codigo === "101900028")); // Shake Mix - Pistache - 200ml
  setPos100700134(products.find(prod => prod.codigo === "100700134")); // Shake Mix - Pistache - 300ml

  setPos100700137(products.find(prod => prod.codigo === "100700137")); // Shake Mix - Amarena & Calda Trufada - 300ml

//   setPos100400106(products.find(prod => prod.codigo === "100400106")); // Milk shake - Receitas especiais - Pink Lemonade - 400ml
//   setPos100500107(products.find(prod => prod.codigo === "100500107")); // Milk shake - Receitas especiais - Pink Lemonade - 500ml

//   setPos100400107(products.find(prod => prod.codigo === "100400107")); // Milk shake - Receitas especiais - Napolitano - 400ml
//   setPos100500106(products.find(prod => prod.codigo === "100500106")); // Milk shake - Receitas especiais - Napolitano - 500ml

//   setPos100400108(products.find(prod => prod.codigo === "100400108")); // Milk shake - Receitas especiais - Três Leites - 400ml
//   setPos100500105(products.find(prod => prod.codigo === "100500105")); // Milk shake - Receitas especiais - Três Leites - 500ml
  setPos100300182(products.find(prod => prod.codigo === "100300182")); // Milk shake - Receitas especiais - Amarena & Calda Quente - 300ml
  setPos100400136(products.find(prod => prod.codigo === "100400136")); // Milk shake - Receitas especiais - Amarena & Calda Quente - 400ml
  setPos100500138(products.find(prod => prod.codigo === "100500138")); // Milk shake - Receitas especiais - Amarena & Calda Quente - 500ml
  setPos100300181(products.find(prod => prod.codigo === "100300181")); // Milk shake - Receitas especiais - Beijinho c/ Coco da Malásia - 300ml
  setPos100400137(products.find(prod => prod.codigo === "100400137")); // Milk shake - Receitas especiais - Beijinho c/ Coco da Malásia - 400ml
  setPos100500139(products.find(prod => prod.codigo === "100500139")); // Milk shake - Receitas especiais - Beijinho c/ Coco da Malásia - 500ml
  setPos100300178(products.find(prod => prod.codigo === "100300178")); // Milk shake - Receitas especiais - Pistache - 300ml
  setPos100400138(products.find(prod => prod.codigo === "100400138")); // Milk shake - Receitas especiais - Pistache - 400ml
  setPos100500140(products.find(prod => prod.codigo === "100500140")); // Milk shake - Receitas especiais - Pistache - 500ml
  setPos100300180(products.find(prod => prod.codigo === "100300180")); // Milk shake - Receitas especiais - Puro Leite - 300ml
  setPos100400135(products.find(prod => prod.codigo === "100400135")); // Milk shake - Receitas especiais - Puro Leite - 400ml
  setPos100500137(products.find(prod => prod.codigo === "100500137")); // Milk shake - Receitas especiais - Puro Leite - 500ml
  setPos100300037(products.find(prod => prod.codigo === "100300037")); // Milk shake - Receitas especiais - Nutella - 300ml
  setPos100400037(products.find(prod => prod.codigo === "100400037")); // Milk shake - Receitas especiais - Nutella - 400ml
  setPos100500037(products.find(prod => prod.codigo === "100500037")); // Milk shake - Receitas especiais - Nutella - 500ml

  setPos100400110(products.find(prod => prod.codigo === "100400110")); // Milk shake - Receitas especiais - Chocotino Turbo - 400ml
  setPos100500110(products.find(prod => prod.codigo === "100500110")); // Milk shake - Receitas especiais - Chocotino Turbo - 500ml

  setPos101900002(products.find(prod => prod.codigo === "101900002")); // Chiquinho & Nutella - Shake mix - Chocotino c/ Nutella - 200ml
  setPos100700005(products.find(prod => prod.codigo === "100700005")); // Chiquinho & Nutella - Shake mix - Chocotino c/ Nutella - 300ml
  setPos101900006(products.find(prod => prod.codigo === "101900006")); // Chiquinho & Nutella - Shake mix - Ninho c/ Nutella - 200ml
  setPos100700023(products.find(prod => prod.codigo === "100700023")); // Shake Mix® Ninho com NUTELLA® 300 ml
  setPos101900020(products.find(prod => prod.codigo === "101900020")); // Chiquinho & Nutella - Shake mix - Trufado de Nutella - 200ml
  setPos100700042(products.find(prod => prod.codigo === "100700042")); // Chiquinho & Nutella - Shake mix - Trufado de Nutella - 300ml
  setPos101900012(products.find(prod => prod.codigo === "101900012")); // Chiquinho & Nutella - Shake mix - Açaí c/ Nutella - 200ml
  setPos100700018(products.find(prod => prod.codigo === "100700018")); // Chiquinho & Nutella - Shake mix - Açaí c/ Nutella - 300ml
  setPos101900029(products.find(prod => prod.codigo === "101900029")); // Chiquinho & Nutella - Shake mix - Morango Supremo (Leite Ninho, Morango e Nutella ) - 200ml
  setPos100700132(products.find(prod => prod.codigo === "100700132")); // Chiquinho & Nutella - Shake mix - Morango Supremo (Leite Ninho, Morango e Nutella ) - 300ml
//   setPos100700014(products.find(prod => prod.codigo === "100700014")); // Chiquinho & Nutella - Shake mix - Nutella c/ Fini - 200ml
//   setPos100700139(products.find(prod => prod.codigo === "100700139")); // Chiquinho & Nutella - Shake mix - Nutella c/ Fini - 300ml

  setPos110000032(products.find(prod => prod.codigo === "110000032")); // Turbine o seu pedido - Nutela
  setPos110000028(products.find(prod => prod.codigo === "110000028")); // Turbine o seu pedido - Leite Ninho
  setPos110000014(products.find(prod => prod.codigo === "110000014")); // Turbine o seu pedido - Chantilly

  setPos101000003(products.find(prod => prod.codigo === "101000003")); // Top fruit - 300ml

  setPos100800020(products.find(prod => prod.codigo === "100800020")); // Sundae - Disqueti
  setPos100800019(products.find(prod => prod.codigo === "100800019")); // Sundae - Brigadeiro

  setPos101500004(products.find(prod => prod.codigo === "101500004")); // Bolinho de Petit Gateau - 1 unidade
  setPos101500005(products.find(prod => prod.codigo === "101500005")); // Bolinho de Petit Gateau - 4 unidades
//   setPos110000013(products.find(prod => prod.codigo === "110000013")); // Casquinhas - 1 unidade
  setPos110000136(products.find(prod => prod.codigo === "110000136")); // Casquinhas - 10 unidades
//   setPos110000011(products.find(prod => prod.codigo === "110000011")); // Cascão - 1 unidade
  setPos110000145(products.find(prod => prod.codigo === "110000145")); // Cascão - 10 unidades

  setPos150100002(products.find(prod => prod.codigo === "150100002")); // Água c/ gás

  

  //Promo - KitKat
//   setPos100200166(products.find(prod => prod.codigo === "100200166")); /*Cascão Kitkat® - Baunilha*/
//   setPos101900116(products.find(prod => prod.codigo === "101900116")); /*Shake Mix KitKat® 200 ml*/
//   setPos100700151(products.find(prod => prod.codigo === "100700151")); /*Shake Mix KitKat® 300 ml*/
  
  //Promo - Especialidades
  setPos100300182(products.find(prod => prod.codigo === "100300182")); /*Milk Shake Amarena & Calda Quente 300 ml*/
  setPos101900105(products.find(prod => prod.codigo === "101900105"));/*Mini Shake Mix Amarena & Calda Trufada*/

  setPos100300181(products.find(prod => prod.codigo === "100300181")); /*Milk Shake Beijinho c/ Coco da Malásia 300 ml*/
  setPos101900104(products.find(prod => prod.codigo === "101900104")); /*Mini Shake Mix Beijinho c/ Coco da Malásia - 200ml*/
  setPos100700138(products.find(prod => prod.codigo === "100700138")); /*Shake Mix Beijinho c/ Coco da Malásia - 300ml*/
  //setPos100200143(products.find(prod => prod.codigo === "100200143")); /*Cascão Trufado c/ Pistache - Baunilha*/
  //setPos100100059(products.find(prod => prod.codigo === "100100059")); /*Casquinha Trufada c/ Pistache - Misto*/
  setPos100300178(products.find(prod => prod.codigo === "100300178")); /*Milk Shake Pistache 300 ml*/
//   setPos100300194(products.find(prod => prod.codigo === "100300194")); /*Milk Shake - Pistache Dubai - 300 ml*/
  //setPos101900026(products.find(prod => prod.codigo === "101900026")); /*Mini Shake Mix Pistache 200 ml*/

  
  
  setPos100300180(products.find(prod => prod.codigo === "100300180")); /*Milk Shake Leitíssimo 300ml*/
  setPos101900103(products.find(prod => prod.codigo === "101900103")); /*Shake Mix - Puro Leite - Leitíssimo - 200ml */

  setPos110000014(products.find(prod => prod.codigo === "110000014"));/**/
  setPos103000247(products.find(prod => prod.codigo === "103000247"));/**/
//   setPos102000195(products.find(prod => prod.codigo === "102000195"));/**/

  //adicionais do splash rosa
  setPos110000032(products.find(prod => prod.codigo === "110000032")); /*Ad Nutella*/
  //setPos110000028(products.find(prod => prod.codigo === "110000028")); /*Ad Leite Ninho*/
  
  //Promo - destaque

    setPos100300176(products.find(prod => prod.codigo === "100300176")); /*Milk-shake Chocotino Turbo - 300ml*/

    setPos101300014(products.find(prod => prod.codigo === "101300014")); /*Big Sundae Chocotino Turbo - 300ml - Chocolate, Baunilha e Misto */


    //Chiquinho & Nutella - Cascão
    //Nutella e Banana
    setPos100200137(products.find(prod => prod.codigo === "100200137"));
    //Nutella e Morango
    setPos100200140(products.find(prod => prod.codigo === "100200140"));

    //milk-shakes - fabulosos
    setPos100300037(products.find(prod => prod.codigo === "100300037"));
    setPos100400037(products.find(prod => prod.codigo === "100400037"));
    setPos100500037(products.find(prod => prod.codigo === "100500037"));

    //milk-shakes - tradicionais
    setPos100300003(products.find(prod => prod.codigo === "100300003"));
    setPos100400003(products.find(prod => prod.codigo === "100400003"));
    setPos100500003(products.find(prod => prod.codigo === "100500003"));

    //milk-shakes - receitas especiais
//     setPos100300171(products.find(prod => prod.codigo === "100300171"));
//     setPos100300170(products.find(prod => prod.codigo === "100300170"));
//     setPos100300169(products.find(prod => prod.codigo === "100300169"));
    setPos100300176(products.find(prod => prod.codigo === "100300176"));

    //shake-mix - insuperaveis
    setPos100700023(products.find(prod => prod.codigo === "100700023")); //Shake Mix® Ninho com NUTELLA® 300 ml
    setPos101900001(products.find(prod => prod.codigo === "101900001"));
    
    //shake-mix - classicos
    setPos100700009(products.find(prod => prod.codigo === "100700009"));
    setPos101900015(products.find(prod => prod.codigo === "101900015"));

    //top-mix
//     setPos100600013(products.find(prod => prod.codigo === "100600013"));
    setPos100600034(products.find(prod => prod.codigo === "100600034"));

    //ovomaltine
    setPos100800049(products.find(prod => prod.codigo === "100800049")); //Sundae - Ovomaltine - 200ml
    setPos100200067(products.find(prod => prod.codigo === "100200067")); //Cascão trufado Ovomaltine
    setPos100100032(products.find(prod => prod.codigo === "100100032"));
    setPos101900019(products.find(prod => prod.codigo === "101900019"));
    setPos100700017(products.find(prod => prod.codigo === "100700017"));

    

    //mix-fruit
    setPos101100003(products.find(prod => prod.codigo === "101100003"));

    //big-sundae
    setPos101300006(products.find(prod => prod.codigo === "101300006"));

    //sundae
    setPos100800014(products.find(prod => prod.codigo === "100800014"));

    //cream tasty
    setPos101000003(products.find(prod => prod.codigo === "101000003"));

    //kids
    setPos100800019(products.find(prod => prod.codigo === "100800019"));
//     setPos100700014(products.find(prod => prod.codigo === "100700014"));

    //casquinhas e cascões
    //tradicionais
    setPos100100013(products.find(prod => prod.codigo === "100100013")); //
    setPos100200043(products.find(prod => prod.codigo === "100200043"));

    //trufados
    setPos100100016(products.find(prod => prod.codigo === "100100016"));
    setPos100200053(products.find(prod => prod.codigo === "100200053"));

    //casquinhas e cascões - trufadas - PISTACHE
    setPos100100057(products.find(prod => prod.codigo === "100100057"));
    setPos100200143(products.find(prod => prod.codigo === "100200143"));

    //calda quente
    setPos100100006(products.find(prod => prod.codigo === "100100006"));
    setPos100100007(products.find(prod => prod.codigo === "100100007"));
    setPos100200004(products.find(prod => prod.codigo === "100200004"));
    setPos100200007(products.find(prod => prod.codigo === "100200007"));

    //petit gateau
    setPos101500001(products.find(prod => prod.codigo === "101500001"));
    setPos101500004(products.find(prod => prod.codigo === "101500004"));
    setPos101500005(products.find(prod => prod.codigo === "101500005"));

    //mini shake mix
    // e
    //receitas especiais
    setPos101900029(products.find(prod => prod.codigo === "101900029"));
    //setPos101900027(products.find(prod => prod.codigo === "101900027"));
    setPos101900028(products.find(prod => prod.codigo === "101900028")); // Mini Shake Mix Pistache 200 ml

    //bubble waffle no cone
//     setPos290900031(products.find(prod => prod.codigo === "290900031")); //bubble waffle P
//     setPos290900022(products.find(prod => prod.codigo === "290900022")); //bubble waffle G

    //bubble waffle no cone: adicionais
//     setPos290900035(products.find(prod => prod.codigo === "290900035")); // Morango P
//     setPos290900001(products.find(prod => prod.codigo === "290900001")); // Morango
//     setPos290900036(products.find(prod => prod.codigo === "290900036")); // Banana P
//     setPos290900002(products.find(prod => prod.codigo === "290900002")); // Banana
//     setPos290900003(products.find(prod => prod.codigo === "290900003")); // Nutella
//     setPos290900004(products.find(prod => prod.codigo === "290900004")); // Doce de Leite
//     setPos290900005(products.find(prod => prod.codigo === "290900005")); // Chocolate Trufado
//     setPos290900037(products.find(prod => prod.codigo === "290900037")); // Polpa de Frutas Vermelhas P
//     setPos290900006(products.find(prod => prod.codigo === "290900006")); // Polpa de Frutas Vermelhas
//     setPos290900045(products.find(prod => prod.codigo === "290900045")); // Polpa de Morango P
//     setPos290900019(products.find(prod => prod.codigo === "290900019")); // Polpa de Morango
//     setPos290900007(products.find(prod => prod.codigo === "290900007")); // Leite Condensado
//     setPos290900008(products.find(prod => prod.codigo === "290900008")); // Suflair
//     setPos290900009(products.find(prod => prod.codigo === "290900009")); // Kitkat

//     setPos290900010(products.find(prod => prod.codigo === "290900010")); // Disqueti P
//     setPos290900034(products.find(prod => prod.codigo === "290900034")); // Disqueti
//     setPos290900038(products.find(prod => prod.codigo === "290900038")); // Biju P
//     setPos290900011(products.find(prod => prod.codigo === "290900011")); // Biju G
//     setPos290900039(products.find(prod => prod.codigo === "290900039")); // Granulado Chocolate P
//     setPos290900012(products.find(prod => prod.codigo === "290900012")); // Granulado Chocolate
//     setPos290900040(products.find(prod => prod.codigo === "290900040")); // Farofa Especial P
//     setPos290900013(products.find(prod => prod.codigo === "290900013")); // Farofa Especial
//     setPos290900041(products.find(prod => prod.codigo === "290900041")); // Amendoim Granulado P
//     setPos290900014(products.find(prod => prod.codigo === "290900014")); // Amendoim Granulado
//     setPos290900042(products.find(prod => prod.codigo === "290900042")); // Ganache Chiquinho P
//     setPos290900015(products.find(prod => prod.codigo === "290900015")); // Ganache Chiquinho
//     setPos290900043(products.find(prod => prod.codigo === "290900043")); // Ovomaltine em Flocos P
//     setPos290900016(products.find(prod => prod.codigo === "290900016")); // Ovomaltine em Flocos
//     setPos290900017(products.find(prod => prod.codigo === "290900017")); // Creme Crocante de Ovomaltine
//     setPos290900044(products.find(prod => prod.codigo === "290900044")); // Marshmallow Fini P
//     setPos290900018(products.find(prod => prod.codigo === "290900018")); // Marshmallow Fini

    //cafés e chocolates
    setPos103000247(products.find(prod => prod.codigo === "103000247"));
    setPos103000098(products.find(prod => prod.codigo === "103000098"));
    setPos103000099(products.find(prod => prod.codigo === "103000099"));
    setPos103000249(products.find(prod => prod.codigo === "103000249"));
//     setPos102000195(products.find(prod => prod.codigo === "102000195"));
//     setPos102000197(products.find(prod => prod.codigo === "102000197"));

    // bebidas
    setPos150100004(products.find(prod => prod.codigo === "150100004"));
    setPos150100002(products.find(prod => prod.codigo === "150100002"));
    //setPos000000001(products.find(prod => prod.codigo === "000000001"));
    //setPos000000002(products.find(prod => prod.codigo === "000000002"));

    //café shake: 300ml
    setPos100300072(products.find(prod => prod.codigo === "100300072"));
    setPos100300070(products.find(prod => prod.codigo === "100300070"));
//     setPos100300071(products.find(prod => prod.codigo === "100300071"));

    setPos100300172(products.find(prod => prod.codigo === "100300172"));
//     setPos100300173(products.find(prod => prod.codigo === "100300173"));

    //açaí
    setPos101400011(products.find(prod => prod.codigo === "101400011"));
    setPos101400013(products.find(prod => prod.codigo === "101400013"));
    setPos101400014(products.find(prod => prod.codigo === "101400014"));

    //açaí: turbine com adicionais
    setPos110000151(products.find(prod => prod.codigo === "110000151"));
    setPos110000176(products.find(prod => prod.codigo === "110000176"));
    setPos110000075(products.find(prod => prod.codigo === "110000075"));
    setPos110000077(products.find(prod => prod.codigo === "110000077"));
    setPos110000149(products.find(prod => prod.codigo === "110000149"));
    setPos110000069(products.find(prod => prod.codigo === "110000069"));
    setPos110000068(products.find(prod => prod.codigo === "110000068"));
    setPos110000172(products.find(prod => prod.codigo === "110000172"));

    //açaí: add especiais
    setPos110000173(products.find(prod => prod.codigo === "110000173"));
    setPos110000174(products.find(prod => prod.codigo === "110000174"));
    setPos110000167(products.find(prod => prod.codigo === "110000167"));
    setPos110000168(products.find(prod => prod.codigo === "110000168"));
    setPos110000169(products.find(prod => prod.codigo === "110000169"));
    setPos110000070(products.find(prod => prod.codigo === "110000070"));
    setPos110000150(products.find(prod => prod.codigo === "110000150"));
    setPos110000072(products.find(prod => prod.codigo === "110000072"));
     
    setPos110000076(products.find(prod => prod.codigo === "110000076"));
    setPos110000071(products.find(prod => prod.codigo === "110000071"));
    setPos110000073(products.find(prod => prod.codigo === "110000073"));
    setPos110000152(products.find(prod => prod.codigo === "110000152"));
    setPos110000153(products.find(prod => prod.codigo === "110000153"));
     
    setPos110000175(products.find(prod => prod.codigo === "110000175"));
    setPos110000171(products.find(prod => prod.codigo === "110000171"));
    setPos110000074(products.find(prod => prod.codigo === "110000074"));
    setPos110000170(products.find(prod => prod.codigo === "110000170"));


    setPos100700132(products.find(prod => prod.codigo === "100700132")); //Shake Mix - Morango Supremo (Leite Ninho, Morango e Nutella ) - 300ml
//     setPos101900110(products.find(prod => prod.codigo === "101900110")); //Mini Shake mix - Pistache Dubai - 200ml

    setPos100300038(products.find(prod => prod.codigo === "100300038"));  // milk shake - Fabulosos - Milk Shake Chocotino - 300 ml
    setPos100400038(products.find(prod => prod.codigo === "100400038"));  // milk shake - Fabulosos - Milk Shake Chocotino - 400ml
    setPos100500038(products.find(prod => prod.codigo === "100500038"));  // milk shake - Fabulosos - Milk Shake Chocotino - 500ml

    //chiquinho no pote
    //incomparáveis
    setPos101700005(products.find(prod => prod.codigo === "101700005"));
    //populares
    setPos101700002(products.find(prod => prod.codigo === "101700002"));

    // Linha Proteica Growth Supplements
    setPos291000004(products.find(prod => prod.codigo === "291000004")); // Açaí 300ml
    setPos291000005(products.find(prod => prod.codigo === "291000005")); // Açaí 400ml
    setPos291000007(products.find(prod => prod.codigo === "291000007")); // Açaí 500ml
    setPos291000001(products.find(prod => prod.codigo === "291000001")); // Açaí com Banana 300ml
    setPos291000002(products.find(prod => prod.codigo === "291000002")); // Açaí com Banana 400ml
    setPos291000003(products.find(prod => prod.codigo === "291000003")); // Açaí com Banana 500ml

    setPos110000022(products.find(prod => prod.codigo === "110000022")); // Doce de leite
    //setPos110000028(products.find(prod => prod.codigo === "110000028")); // Leite em pó
    setPos110000027(products.find(prod => prod.codigo === "110000027")); // Leite Moça
    setPos110000130(products.find(prod => prod.codigo === "110000130")); // Granola
    setPos110000261(products.find(prod => prod.codigo === "110000261")); // Whey
    setPos110000024(products.find(prod => prod.codigo === "110000024")); // Farofa especial

    setPos101900123(products.find(prod => prod.codigo === "101900123")); // Banoffee 200ml
    setPos100700153(products.find(prod => prod.codigo === "100700153")); // Banoffee 300ml
    setPos101900124(products.find(prod => prod.codigo === "101900124")); // Farinha Láctea c/ Banana 200ml
    setPos100700154(products.find(prod => prod.codigo === "100700154")); // Farinha Láctea c/ Banana 300ml

    setPos100300203(products.find(prod => prod.codigo === "100300203")); // Chocolate 300ml
    setPos100400147(products.find(prod => prod.codigo === "100400147")); // Chocolate 400ml
    setPos100500149(products.find(prod => prod.codigo === "100500149")); // Chocolate 500ml
    setPos100300206(products.find(prod => prod.codigo === "100300206")); // Morango 300ml
    setPos100400150(products.find(prod => prod.codigo === "100400150")); // Morango 400ml
    setPos100500152(products.find(prod => prod.codigo === "100500152")); // Morango 500ml
    setPos100300204(products.find(prod => prod.codigo === "100300204")); // Duo Chocolate 300ml
    setPos100400148(products.find(prod => prod.codigo === "100400148")); // Duo Chocolate 400ml
    setPos100500150(products.find(prod => prod.codigo === "100500150")); // Duo Chocolate 500ml
    setPos100300205(products.find(prod => prod.codigo === "100300205")); // Maracujá 300ml
    setPos100400149(products.find(prod => prod.codigo === "100400149")); // Maracujá 400ml
    setPos100500151(products.find(prod => prod.codigo === "100500151")); // Maracujá 500ml
    setPos100300207(products.find(prod => prod.codigo === "100300207")); // Leite em pó 300ml
    setPos100400151(products.find(prod => prod.codigo === "100400151")); // Leite em pó 400ml
    setPos100500153(products.find(prod => prod.codigo === "100500153")); // Leite em pó 500ml

    }
  }, [products]);

  function handleClickButtonModalCatchPrecos() {
    setMostraModalCatchPrecos(false);
    history.push('/');
  }

  function Indisponivel(props) {
    return <span className={String(props.tamanho)}>Indisponível</span>;
  }

  // function Indisponivel2(props) {
  //   return <span className={String(props.tamanho)}></span>;
  // }

  // const indisponivel_1vw = (
  //   <Indisponivel tamanho="font-size-1vw indisponivel" />
  // );

  const indisponivel_1_1vw = (
    <Indisponivel tamanho="font-size-1-1vw indisponivel" />
  );

  // const indisponivel_2vw = (
  //   <Indisponivel2 tamanho="font-size-1-1vw indisponivel" />
  // );

  // const indisponivel_1_2vw = (
  //   <Indisponivel tamanho="font-size-1-2vw indisponivel" />
  // );

  // const indisponivel_1_3vw = (
  //   <Indisponivel tamanho="font-size-1-3vw indisponivel" />
  // );

  // const indisponivel_1_4vw = (
  //   <Indisponivel tamanho="font-size-1-4vw indisponivel" />
  // );

  // const indisponivel_1_5vw = (
  //   <Indisponivel tamanho="font-size-1-5vw indisponivel" />
  // );

  // const indisponivel_1_7vw = (
  //   <Indisponivel tamanho="font-size-1-7vw indisponivel" />
  // );

  // const indisponivel_1_9vw = (
  //   <Indisponivel tamanho="font-size-1-9vw indisponivel" />
  // );

  return (
    <>
      <section id="parte1">


            <section className="categoria parteGrowth">

              {/*Smoothie Proteico*/}
              <span className="val-1 valor">{pos291000004 && pos291000004.preco ? pos291000004.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Açaí 300ml*/}
              <span className="val-2 valor">{pos291000005 && pos291000005.preco ? pos291000005.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Açaí 400ml*/}
              <span className="val-3 valor">{pos291000007 && pos291000007.preco ? pos291000007.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Açaí 500ml*/}
              <span className="val-4 valor">{pos291000001 && pos291000001.preco ? pos291000001.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Açaí com Banana 300ml*/}
              <span className="val-5 valor">{pos291000002 && pos291000002.preco ? pos291000002.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Açaí com Banana 400ml*/}
              <span className="val-6 valor">{pos291000003 && pos291000003.preco ? pos291000003.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Açaí com Banana 500ml*/}

              {/*Turbine seu Smoothie com adicionais*/}
              <span className="val-7 valor">{pos110000022 && pos110000022.preco ? pos110000022.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Doce de leite*/}
              <span className="val-8 valor">{pos110000028 && pos110000028.preco ? pos110000028.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Leite em pó*/}
              <span className="val-9 valor">{pos110000027 && pos110000027.preco ? pos110000027.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Leite Moça*/}
              <span className="val-10 valor">{pos110000130 && pos110000130.preco ? pos110000130.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Granola*/}
              <span className="val-11 valor">{pos110000261 && pos110000261.preco ? pos110000261.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Whey*/}
              <span className="val-12 valor">{pos110000024 && pos110000024.preco ? pos110000024.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Farofa especial*/}

              {/*Shake Mix Proteico*/}
              <span className="val-13 valor">{pos101900123 && pos101900123.preco ? pos101900123.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Banoffee 200ml*/}
              <span className="val-14 valor">{pos100700153 && pos100700153.preco ? pos100700153.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Banoffee 300ml*/}
              <span className="val-15 valor">{pos101900124 && pos101900124.preco ? pos101900124.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Farinha Láctea c/ Banana 200ml*/}
              <span className="val-16 valor">{pos100700154 && pos100700154.preco ? pos100700154.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Farinha Láctea c/ Banana 300ml*/}

              {/*Milk Shake Proteico*/}
              <span className="val-17 valor">{pos100300203 && pos100300203.preco ? pos100300203.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Chocolate 300ml*/}
              <span className="val-18 valor">{pos100400147 && pos100400147.preco ? pos100400147.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Chocolate 400ml*/}
              <span className="val-19 valor">{pos100500149 && pos100500149.preco ? pos100500149.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Chocolate 500ml*/}
              <span className="val-20 valor">{pos100300206 && pos100300206.preco ? pos100300206.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Morango 300ml*/}
              <span className="val-21 valor">{pos100400150 && pos100400150.preco ? pos100400150.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Morango 400ml*/}
              <span className="val-22 valor">{pos100500152 && pos100500152.preco ? pos100500152.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Morango 500ml*/}
              <span className="val-23 valor">{pos100300204 && pos100300204.preco ? pos100300204.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Duo Chocolate 300ml*/}
              <span className="val-24 valor">{pos100400148 && pos100400148.preco ? pos100400148.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Duo Chocolate 400ml*/}
              <span className="val-25 valor">{pos100500150 && pos100500150.preco ? pos100500150.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Duo Chocolate 500ml*/}
              <span className="val-26 valor">{pos100300205 && pos100300205.preco ? pos100300205.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Maracujá 300ml*/}
              <span className="val-27 valor">{pos100400149 && pos100400149.preco ? pos100400149.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Maracujá 400ml*/}
              <span className="val-28 valor">{pos100500151 && pos100500151.preco ? pos100500151.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Maracujá 500ml*/}
              <span className="val-29 valor">{pos100300207 && pos100300207.preco ? pos100300207.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Leite em pó 300ml*/}
              <span className="val-30 valor">{pos100400151 && pos100400151.preco ? pos100400151.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Leite em pó 400ml*/}
              <span className="val-31 valor">{pos100500153 && pos100500153.preco ? pos100500153.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Leite em pó 500ml*/}

              <span className="val-32 valor">{pos110000261 && pos110000261.preco ? pos110000261.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*1 Scoop Growth*/}

              <img src={parteGrowth} alt="parteGrowth" />

            </section>

            <section className="categoria parte1">

              <span className="val-1 valor">{pos102000298 && pos102000298.preco ? pos102000298.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Torta de Morango*/}
              <span className="val-2 valor">{pos102000324 && pos102000324.preco ? pos102000324.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Merengue de Limão*/}
              <span className="val-3 valor">{pos102000348 && pos102000348.preco ? pos102000348.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Merengue de Morango*/}
              <span className="val-4 valor">{pos102000336 && pos102000336.preco ? pos102000336.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Floresta Negra*/}
              <span className="val-5 valor">{pos102000311 && pos102000311.preco ? pos102000311.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*S´mores*/}
              
              <span className="val-6 valor">{pos102000279 && pos102000279.preco ? pos102000279.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Monte o seu canecake*/}

              <span className="val-7 valor">{pos110000259 && pos110000259.preco ? pos110000259.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Suspiro*/}
              <span className="val-8 valor">{pos110000203 && pos110000203.preco ? pos110000203.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Morango*/}
              <span className="val-9 valor">{pos110000206 && pos110000206.preco ? pos110000206.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Doce de Leite*/}
              <span className="val-10 valor">{pos110000256 && pos110000256.preco ? pos110000256.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Creme Amarena*/}
              <span className="val-11 valor">{pos110000207 && pos110000207.preco ? pos110000207.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Chocolate Trufado*/}
              <span className="val-12 valor">{pos110000204 && pos110000204.preco ? pos110000204.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Banana*/}
              <span className="val-13 valor">{pos110000208 && pos110000208.preco ? pos110000208.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Creme de Leite em Pó*/}
              <span className="val-14 valor">{pos110000205 && pos110000205.preco ? pos110000205.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*NUTELLA*/}
              <span className="val-15 valor">{pos110000210 && pos110000210.preco ? pos110000210.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Leite Moça*/}
              <span className="val-16 valor">{pos110000231 && pos110000231.preco ? pos110000231.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Creme de Pistache*/}
              <span className="val-17 valor">{pos110000258 && pos110000258.preco ? pos110000258.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Marshmallow Cremoso - Recheio*/}
              <span className="val-18 valor">{pos110000213 && pos110000213.preco ? pos110000213.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Disqueti*/}
              <span className="val-19 valor">{pos110000214 && pos110000214.preco ? pos110000214.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Calda de Fondue*/}
              <span className="val-20 valor">{pos110000242 && pos110000242.preco ? pos110000242.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Creme Coco da Malásia*/}
              <span className="val-21 valor">{pos110000222 && pos110000222.preco ? pos110000222.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Creme Crocante Ovomaltine*/}

              {/*Top Fondue*/}
              <span className="val-22 valor">{pos102000269 && pos102000269.preco ? pos102000269.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Top Fondue - Banana*/}
              <span className="val-23 valor">{pos102000265 && pos102000265.preco ? pos102000265.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Top Fondue - Morango*/}
              <span className="val-24 valor">{pos102000272 && pos102000272.preco ? pos102000272.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Top Fondue - Uva*/}

              {/*Fondue*/}
              <span className="val-25 valor">{pos102000256 && pos102000256.preco ? pos102000256.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Fondue - Banana - 200ml*/}
              <span className="val-26 valor">{pos102000259 && pos102000259.preco ? pos102000259.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Fondue - Banana - 300ml*/}

              <span className="val-27 valor">{pos102000257 && pos102000257.preco ? pos102000257.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Fondue - Morango - 200ml*/}
              <span className="val-28 valor">{pos102000258 && pos102000258.preco ? pos102000258.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Fondue - Morango - 300ml*/}

              <span className="val-29 valor">{pos102000260 && pos102000260.preco ? pos102000260.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Fondue - Uva - 200ml*/}
              <span className="val-30 valor">{pos102000261 && pos102000261.preco ? pos102000261.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Fondue - Uva - 300ml*/}

              {/*Mix Fondue*/}
              <span className="val-31 valor">{pos102000262 && pos102000262.preco ? pos102000262.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Mix Fondue - Banana, Morango e Uva - 200ml*/}
              <span className="val-32 valor">{pos102000263 && pos102000263.preco ? pos102000263.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Mix Fondue - Banana, Morango e Uva - 300ml*/}

              {/*Cafés*/}
              <span className="val-33 valor">{pos103000247 && pos103000247.preco ? pos103000247.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Café - Affogato - 200ml*/}
              <span className="val-34 valor">{pos102000349 && pos102000349.preco ? pos102000349.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Café - Cappuccino - 200ml*/}

              

              
              <img src={parte1} alt="parte1" />

            </section>

            <section className="categoria parte2">

              {/*shake mix - receitas especiais*/}
              <span className="val-1 valor">{pos101900026 && pos101900026.preco ? pos101900026.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix - Banoffee - 200ml*/}
              <span className="val-2 valor">{pos100700135 && pos100700135.preco ? pos100700135.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix - Banoffee - 300ml*/}

              <span className="val-3 valor">{pos101900104 && pos101900104.preco ? pos101900104.preco.toFixed(2) : indisponivel_1_1vw}</span>  {/*shake mix - receitas especiais - Beijinho c/ Coco da Malásia - 200ml*/}
              <span className="val-4 valor">{pos100700138 && pos100700138.preco ? pos100700138.preco.toFixed(2) : indisponivel_1_1vw}</span>  {/*shake mix - receitas especiais - Beijinho c/ Coco da Malásia - 300ml*/}
              
              <span className="val-5 valor">{pos101900029 && pos101900029.preco ? pos101900029.preco.toFixed(2) : indisponivel_1_1vw}</span>  {/*shake mix - receitas especiais - Morango Supremo - 200ml*/}
              <span className="val-6 valor">{pos100700132 && pos100700132.preco ? pos100700132.preco.toFixed(2) : indisponivel_1_1vw}</span>  {/*shake mix - receitas especiais - Morango Supremo - 300ml*/}

              <span className="val-7 valor">{pos101900103 && pos101900103.preco ? pos101900103.preco.toFixed(2) : indisponivel_1_1vw}</span>  {/*shake mix - receitas especiais - Puro Leite - 200ml*/}
              <span className="val-8 valor">{pos100700136 && pos100700136.preco ? pos100700136.preco.toFixed(2) : indisponivel_1_1vw}</span>  {/*shake mix - receitas especiais - Puro Leite - 300ml*/}
              
              <span className="val-9 valor">{pos101900028 && pos101900028.preco ? pos101900028.preco.toFixed(2) : indisponivel_1_1vw}</span>  {/*shake mix - receitas especiais - Pistache - 200ml*/}
              <span className="val-10 valor">{pos100700134 && pos100700134.preco ? pos100700134.preco.toFixed(2) : indisponivel_1_1vw}</span>  {/*shake mix - receitas especiais - Pistache - 300ml*/}
              
              <span className="val-11 valor">{pos101900027 && pos101900027.preco ? pos101900027.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix - Torta de Limão - 200ml*/}
              <span className="val-12 valor">{pos100700133 && pos100700133.preco ? pos100700133.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix - Torta de Limão - 300ml*/}

              <span className="val-13 valor">{pos101900105 && pos101900105.preco ? pos101900105.preco.toFixed(2) : indisponivel_1_1vw}</span>  {/*shake mix - receitas especiais - Amarena & Calda Trufada - 200ml*/}
              <span className="val-14 valor">{pos100700137 && pos100700137.preco ? pos100700137.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*shake mix - receitas especiais - Amarena & Calda Trufada - 300ml*/}
              

              {/*shake mix - insuperáveis*/}
              <span className="val-15 valor">{pos101900001 && pos101900001.preco ? pos101900001.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix® Ninho com NUTELLA® 200 ml*/}
              <span className="val-16 valor">{pos100700023 && pos100700023.preco ? pos100700023.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix® Ninho com NUTELLA® 300 ml*/} 
              
              {/*shake mix - clássicos*/}
              <span className="val-17 valor">{pos101900015 && pos101900015.preco ? pos101900015.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*shake mix - clássicos - 200ml*/}              
              <span className="val-18 valor">{pos100700009 && pos100700009.preco ? pos100700009.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*shake mix - clássicos - 300ml*/} 

              <img src={parte2} alt="parte2" />

            </section>


            <section className="categoria parte3">


              {/*milk shake - receitas especiais*/}
              <span className="val-1 valor">{pos100300182 && pos100300182.preco ? pos100300182.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Amarena & Calda Quente - 300ml*/}
              <span className="val-2 valor">{pos100400136 && pos100400136.preco ? pos100400136.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Amarena & Calda Quente - 400ml*/}
              <span className="val-3 valor">{pos100500138 && pos100500138.preco ? pos100500138.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Amarena & Calda Quente - 500ml*/}
              
              <span className="val-4 valor">{pos100300181 && pos100300181.preco ? pos100300181.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Beijinho c/ Coco da Malásia - 300ml*/}
              <span className="val-5 valor">{pos100400137 && pos100400137.preco ? pos100400137.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Beijinho c/ Coco da Malásia - 400ml*/}
              <span className="val-6 valor">{pos100500139 && pos100500139.preco ? pos100500139.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Beijinho c/ Coco da Malásia - 500ml*/}

              <span className="val-7 valor">{pos100300178 && pos100300178.preco ? pos100300178.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Pistache - 300ml*/}
              <span className="val-8 valor">{pos100400138 && pos100400138.preco ? pos100400138.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Pistache - 400ml*/}
              <span className="val-9 valor">{pos100500140 && pos100500140.preco ? pos100500140.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Pistache - 500ml*/}

              <span className="val-10 valor">{pos100300180 && pos100300180.preco ? pos100300180.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Puro Leite - 300ml*/}
              <span className="val-11 valor">{pos100400135 && pos100400135.preco ? pos100400135.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Puro Leite - 400ml*/}
              <span className="val-12 valor">{pos100500137 && pos100500137.preco ? pos100500137.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Puro Leite - 500ml*/}

              <span className="val-13 valor">{pos100300037 && pos100300037.preco ? pos100300037.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Nutella - 300ml*/}
              <span className="val-14 valor">{pos100400037 && pos100400037.preco ? pos100400037.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Nutella - 400ml*/}
              <span className="val-15 valor">{pos100500037 && pos100500037.preco ? pos100500037.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Nutella - 500ml*/}

              <span className="val-16 valor">{pos100300176 && pos100300176.preco ? pos100300176.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Chocotino Turbo - 300ml*/}
              <span className="val-17 valor">{pos100400110 && pos100400110.preco ? pos100400110.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Chocotino Turbo - 400ml*/}
              <span className="val-18 valor">{pos100500110 && pos100500110.preco ? pos100500110.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - receitas especiais - Chocotino Turbo - 500ml*/}

              {/*milk shake - fabulosos*/}
              <span className="val-19 valor">{pos100300038 && pos100300038.preco ? pos100300038.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - Fabulosos - Milk Shake Chocotino - 300 ml*/}
              <span className="val-20 valor">{pos100400038 && pos100400038.preco ? pos100400038.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - Fabulosos - Milk Shake Chocotino - 400ml*/}
              <span className="val-21 valor">{pos100500038 && pos100500038.preco ? pos100500038.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - Fabulosos - Milk Shake Chocotino - 500ml*/}

              {/*milk shake - tradicionais*/}
              <span className="val-22 valor">{pos100300003 && pos100300003.preco ? pos100300003.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - tradicionais - 300ml*/}
              <span className="val-23 valor">{pos100400003 && pos100400003.preco ? pos100400003.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - tradicionais - 400ml*/}
              <span className="val-24 valor">{pos100500003 && pos100500003.preco ? pos100500003.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - tradicionais - 500ml*/}

              {/*cafés shake - 300ml*/}
              <span className="val-25 valor">{pos100300072 && pos100300072.preco ? pos100300072.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*café shake - Nutella - 300ml*/}
              <span className="val-26 valor">{pos100300070 && pos100300070.preco ? pos100300070.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*café shake - Tradicional - 300ml*/}
              <span className="val-27 valor">{pos100300172 && pos100300172.preco ? pos100300172.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*café shake - Trufado - 300ml*/}
              
              <img src={parte3} alt="parte3" />

            </section>

        <section className="categoria parte4">

          {/*Chiquinho & Nutella*/}
          <span className="val-1 valor">{pos100300037 && pos100300037.preco ? pos100300037.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - Nutella - 300ml*/}
          <span className="val-2 valor">{pos100400037 && pos100400037.preco ? pos100400037.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - Nutella - 400ml*/}
          <span className="val-3 valor">{pos100500037 && pos100500037.preco ? pos100500037.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*milk shake - Nutella - 500ml*/}

          <span className="val-4 valor">{pos100200137 && pos100200137.preco ? pos100200137.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Cascão - Nutella e Banana*/}
          <span className="val-5 valor">{pos100200140 && pos100200140.preco ? pos100200140.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Cascão - Nutella e Morango*/}

          <span className="val-6 valor"> {pos101900002 && pos101900002.preco ? pos101900002.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix - Nutella - Chocotino c/ Nutella - 200ml*/}
          <span className="val-7 valor"> {pos100700005 && pos100700005.preco ? pos100700005.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix - Nutella - Chocotino c/ Nutella - 300ml*/}
          
          <span className="val-8 valor"> {pos101900006 && pos101900006.preco ? pos101900006.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix - Ninho com NUTELLA® - 200ml*/}
          <span className="val-9 valor"> {pos100700023 && pos100700023.preco ? pos100700023.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix - Ninho com NUTELLA® - 300 ml*/}
          
          <span className="val-10 valor">{pos101900020 && pos101900020.preco ? pos101900020.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix - Nutella - Trufado de Nutella - 200ml*/}
          <span className="val-11 valor">{pos100700042 && pos100700042.preco ? pos100700042.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix - Nutella - Trufado de Nutella - 300ml*/}
          
          <span className="val-12 valor">{pos101900012 && pos101900012.preco ? pos101900012.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix - Nutella - Açaí c/ Nutella - 200ml*/}
          <span className="val-13 valor">{pos100700018 && pos100700018.preco ? pos100700018.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix - Nutella - Açaí c/ Nutella - 300ml*/}
          
          <span className="val-14 valor">{pos101900029 && pos101900029.preco ? pos101900029.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix - Nutella - Morango Supremo - 200ml*/}
          <span className="val-15 valor">{pos100700132 && pos100700132.preco ? pos100700132.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Shake Mix - Nutella - Morango Supremo - 300ml*/}
          
          <span className="val-16 valor">{pos110000032 && pos110000032.preco ? pos110000032.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Chiquinho & Nutella - Turbine - Nutella*/}
          <span className="val-17 valor">{pos110000028 && pos110000028.preco ? pos110000028.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Chiquinho & Nutella - Turbine - Leite Ninho*/}
          <span className="val-18 valor">{pos110000014 && pos110000014.preco ? pos110000014.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Chiquinho & Nutella - Turbine - Chantilly*/}
          <span className="val-19 valor">{pos150100004 && pos150100004.preco ? pos150100004.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Chiquinho & Nutella - Turbine - Água s/ Gás*/}
          <span className="val-20 valor">{pos150100002 && pos150100002.preco ? pos150100002.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Chiquinho & Nutella - Turbine - Água c/ Gás*/}

          <img src={parte4} alt="parte4" />

        </section>

        <section className="categoria parte5">

          {/*Top mix*/}
          <span className="val-1 valor">{pos100600034 && pos100600034.preco ? pos100600034.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*top mix - frutas - 300ml*/}

          {/*Petit gateau*/}
          <span className="val-2 valor">{pos101500001 && pos101500001.preco ? pos101500001.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Bolinho de Petit Gateau + sorvete*/}
          <span className="val-3 valor">{pos101500004 && pos101500004.preco ? pos101500004.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Bolinho de Petit Gateau - 1 unidade - 80g*/}
          <span className="val-4 valor">{pos101500005 && pos101500005.preco ? pos101500005.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Bolinho de Petit Gateau - 4 unidades - 320g*/}

          <span className="val-5 valor">{pos101000003 && pos101000003.preco ? pos101000003.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Top fruit - 300ml*/}
          <span className="val-6 valor">{pos101100003 && pos101100003.preco ? pos101100003.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Mix fruit - 200ml*/}

          {/*Chiquinho e Ovomaltine*/}
          <span className="val-7 valor"> {pos101900019 && pos101900019.preco ? pos101900019.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Ovomaltine Mix - 200ml*/}
          <span className="val-8 valor"> {pos100700017 && pos100700017.preco ? pos100700017.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Ovomaltine Mix - 300ml*/}
          <span className="val-9 valor">{pos100200067 && pos100200067.preco ? pos100200067.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Cascão trufado - Ovomaltine*/}
          <span className="val-10 valor">{pos100800049 && pos100800049.preco ? pos100800049.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Sundae - Ovomaltine - 200ml*/}
          <span className="val-11 valor">{pos100100032 && pos100100032.preco ? pos100100032.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Casquinha trufada - Ovomaltine*/}

          <img src={parte5} alt="parte5" />

        </section>

        <section className="categoria parte6">

          {/*Big sundae*/}
          <span className="val-1 valor">{pos101300006 && pos101300006.preco ? pos101300006.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Big sundae - Tradicional - 300ml*/}
          <span className="val-2 valor">{pos101300014 && pos101300014.preco ? pos101300014.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Big sundae - Chocotino Turbo*/}
          
          {/*sundae*/}
          <span className="val-3 valor">{pos100800014 && pos100800014.preco ? pos100800014.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Sundae - Tradicional - 200ml*/}
          <span className="val-4 valor">{pos100800020 && pos100800020.preco ? pos100800020.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Sundae - Disqueti - 200ml*/}
          <span className="val-5 valor">{pos100800019 && pos100800019.preco ? pos100800019.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Sundae - Brigadeiro - 200ml*/}

          {/*Casquinhas & Cascões*/}

          {/*Tradicionais*/}
          <span className="val-7 valor">{pos100100013 && pos100100013.preco ? pos100100013.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Tradicionais - Casquinha*/}
          <span className="val-8 valor">{pos100200043 && pos100200043.preco ? pos100200043.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Tradicionais - Cascão*/}

          {/*Trufadas*/}
          <span className="val-9 valor"> {pos100100016 && pos100100016.preco ? pos100100016.preco.toFixed(2) : indisponivel_1_1vw}</span>  {/*Trufadas - Casquinha*/} 
          <span className="val-10 valor">{pos100200053 && pos100200053.preco ? pos100200053.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Trufadas - Cascão*/}

          {/*Trufadas - Pistache*/}
          <span className="val-11 valor">{pos100100057 && pos100100057.preco ? pos100100057.preco.toFixed(2) : indisponivel_1_1vw}</span>  {/*Trufadas - Pistache - Casquinha*/} 
          <span className="val-12 valor">{pos100200143 && pos100200143.preco ? pos100200143.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Trufadas - Pistache - Cascão*/}

          {/*calda quente*/}
          <span className="val-13 valor">{pos100100006 && pos100100006.preco ? pos100100006.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*calda quente - Cobertos - Casquinha*/}
          <span className="val-14 valor">{pos100100007 && pos100100007.preco ? pos100100007.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*calda quente - Cobertos - Cascão*/}
          <span className="val-15 valor">{pos100200004 && pos100200004.preco ? pos100200004.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*calda quente - Recheados - Casquinha*/}
          <span className="val-16 valor">{pos100200007 && pos100200007.preco ? pos100200007.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*calda quente - Recheados - Cascão*/}


          {/*cafés e chocolates*/}
          <span className="val-17 valor">{pos103000247 && pos103000247.preco ? pos103000247.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Affogato*/}
          <span className="val-18 valor">{pos103000098 && pos103000098.preco ? pos103000098.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Café Expresso*/}
          <span className="val-19 valor">{pos103000099 && pos103000099.preco ? pos103000099.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Café Expresso c/ Chantilly*/}
          <span className="val-20 valor">{pos103000249 && pos103000249.preco ? pos103000249.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Cappuccino c/ Suflair*/}

          {/*bebidas*/}
          <span className="val-21 valor">{pos150100004 && pos150100004.preco ? pos150100004.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Água sem gás*/}
          <span className="val-22 valor">{pos150100002 && pos150100002.preco ? pos150100002.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Água com gás*/}
          <span className="val-23 valor consultar-caixa">Consultar no caixa</span> {/*Refrigerante*/}
          <span className="val-24 valor consultar-caixa">Consultar no caixa</span> {/*Suco*/}

          <img src={parte6} alt="parte6" />

        </section>

        <section className="categoria parte8">

          <span className="val-1 valor">{pos101700005 && pos101700005.preco ? pos101700005.preco.toFixed(2) : indisponivel_1_1vw}</span>{/*chiquinho no pote - incomparaveis*/}
          <span className="val-2 valor">{pos101700002 && pos101700002.preco ? pos101700002.preco.toFixed(2) : indisponivel_1_1vw}</span>{/*chiquinho no pote - populares*/}

          {/*Leve para acompanhar o seu pote*/}
          <span className="val-3 valor">{pos101500004 && pos101500004.preco ? pos101500004.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Bolinho de Petit Gateau - 1 unidade*/}
          <span className="val-4 valor">{pos101500005 && pos101500005.preco ? pos101500005.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Bolinho de Petit Gateau - 4 unidades*/}
          <span className="val-5 valor">{pos110000136 && pos110000136.preco ? pos110000136.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Casquinhas - 10 unidades*/}
          <span className="val-6 valor">{pos110000145 && pos110000145.preco ? pos110000145.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Cascão - 10 unidades*/}



          <img src={parte8} alt="parte8" />

        </section>

        <section className="categoria parte9">


          {/*Dobra 1*/}
          {/*Açaí*/}
          <span className="val-1 valor">{pos101400011 && pos101400011.preco ? pos101400011.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Açaí Puro - 300ml*/}
          <span className="val-2 valor">{pos101400013 && pos101400013.preco ? pos101400013.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Açaí Puro - 400ml*/}
          <span className="val-3 valor">{pos101400014 && pos101400014.preco ? pos101400014.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Açaí Puro - 500ml*/}

          {/*turbine com adicionais*/}
          <span className="val-4 valor">{pos110000069 && pos110000069.preco ? pos110000069.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Banana*/}
          <span className="val-5 valor">{pos110000077 && pos110000077.preco ? pos110000077.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Granola*/}
          <span className="val-6 valor">{pos110000073 && pos110000073.preco ? pos110000073.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Leite Moça*/}

          <span className="val-7 valor">{pos110000071 && pos110000071.preco ? pos110000071.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Leite Ninho*/}
          <span className="val-8 valor">{pos110000068 && pos110000068.preco ? pos110000068.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Morango*/}
          <span className="val-9 valor">{pos110000153 && pos110000153.preco ? pos110000153.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Nutella*/}

          <span className="val-10 valor">{pos110000149 && pos110000149.preco ? pos110000149.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Amendoim*/}
          <span className="val-11 valor">{pos110000170 && pos110000170.preco ? pos110000170.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Biscoito Negresco*/}
          <span className="val-12 valor">{pos110000176 && pos110000176.preco ? pos110000176.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Biju Wafer*/}
          <span className="val-13 valor">{pos110000150 && pos110000150.preco ? pos110000150.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Chantilly*/}
          <span className="val-14 valor">{pos110000152 && pos110000152.preco ? pos110000152.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Creme Crocante Ovomaltine*/}
          <span className="val-15 valor">{pos110000169 && pos110000169.preco ? pos110000169.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Doce de Leite*/}
          <span className="val-16 valor">{pos110000072 && pos110000072.preco ? pos110000072.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Farinha Láctea*/}
          <span className="val-17 valor">{pos110000075 && pos110000075.preco ? pos110000075.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Farofa Especial*/}
          <span className="val-18 valor">{pos110000167 && pos110000167.preco ? pos110000167.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Ganache de Chocolate*/}
          <span className="val-19 valor">{pos110000151 && pos110000151.preco ? pos110000151.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Granulado de Chocolate*/}

          <span className="val-20 valor">{pos110000171 && pos110000171.preco ? pos110000171.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Marshmallow Torção Fini*/}
          <span className="val-21 valor">{pos110000074 && pos110000074.preco ? pos110000074.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Mini Disqueti*/}
          <span className="val-22 valor">{pos110000076 && pos110000076.preco ? pos110000076.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Ovomaltine*/}
          <span className="val-23 valor">{pos110000175 && pos110000175.preco ? pos110000175.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Ouro Branco*/}
          <span className="val-24 valor">{pos110000174 && pos110000174.preco ? pos110000174.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Polpa de Frutas Vermelhas*/}
          <span className="val-25 valor">{pos110000173 && pos110000173.preco ? pos110000173.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Polpa de Maracujá*/}
          <span className="val-26 valor">{pos110000172 && pos110000172.preco ? pos110000172.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Polpa de Morango*/}
          <span className="val-27 valor">{pos110000070 && pos110000070.preco ? pos110000070.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Sorvete (Chocolate, Baunilha ou Misto)*/}
          <span className="val-28 valor">{pos110000168 && pos110000168.preco ? pos110000168.preco.toFixed(2) : indisponivel_1_1vw}</span> {/*Trufada*/}

          <img src={parte9} alt="parte9" />

        </section>


      </section>

      <Dialog
        className="dialog-loadding"
        header="Carregando Informações"
        visible={loadingModal}
        closable={false}
        onHide={() => setLoaddingModal(false)}
      >
        <main
          style={{
            padding: '1em',
            justifyContent: 'center',
            display: 'flex',
          }}
        >
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '2em' }}></i>
        </main>
      </Dialog>

      <Dialog
        header="Problemas para buscar preços"
        className="dialog-footer"
        visible={mostraModalCatchPrecos}
        onHide={() => setMostraModalCatchPrecos(false)}
        footer={
          <Button
            label="Ok"
            icon="pi pi-check"
            onClick={() => handleClickButtonModalCatchPrecos()}
            autoFocus
          />
        }
      >
        <p>
          Não Foi possível carregar os preçoes da franquia, tente novamente mais tarde!
        </p>
      </Dialog>
    </>
  );
};

export default CardapioOnlineFull;
